<div id="live-chat" *ngIf="!(extendedMirror && reduced)">
  <div class="live-chat-header">
    <h3>{{ 'agent:panel.chat.header.name' | translate }}</h3>

    <!-- COPY LAYER MENU -->
    <mat-menu #copyLayerMenu="matMenu" xPosition="before">
      <chat-copy-layer (copyToRoom)="copyAllMessagesToRoom($event)"></chat-copy-layer>
    </mat-menu>

    <!-- COPY ATTACHMENTS MENU -->
    <mat-menu #copyAttachmentsMenu="matMenu" xPosition="before">
      <ng-container *ngFor="let msg of getAttachmentList()">
        <a
          mat-menu-item
          [title]="[msg.attachment.fileName, msg.attachment.fileSize | fileSize] | joiner: ' - '"
          (click)="downloadFile(msg)"
        >
          <span class="tab-text">{{ msg.attachment.fileName }}</span>
        </a>
      </ng-container>
    </mat-menu>

    <button
      mat-icon-button
      *ngIf="extendedMirror"
      (click)="reduced = !reduced"
      class="cng-ico_win_reduire global-icon"
      title="{{ 'agent:panel.chat.button.reduce' | translate }}"
    ></button>
    <!-- COPY ATTACHMENTS MENU TRIGGER -->
    <button
      mat-icon-button
      [matMenuTriggerFor]="copyAttachmentsMenu"
      *ngIf="chat.chatAttachmentCount > 0"
      class="cng-ico_attach flex-row-reverse align-items-center button-attachement"
    >
      <span counter>{{ chat.chatAttachmentCount }}</span>
    </button>

    <!-- COPY LAYER MENU TRIGGER -->
    <button mat-icon-button [matMenuTriggerFor]="copyLayerMenu" class="cng-ico_menu_bullets"></button>
  </div>
  <div class="chat">
    <ul class="chat-history" #chatListChanged>
      <li class="empty-li-for-alignment" aria-hidden="true"></li>
      <li
        *ngFor="let chatMessage of chatSocketService.activeChat.messages"
        [ngClass]="{
          'chat-message-agent':
            chatMessage.isFromRealAgent() && (chatMessage.type === 'CHAT' || chatMessage.type === 'CHAT_AUTOMATIC_MESSAGE'),
          'chat-message-visitor': chatMessage.isFromCustomer() && chatMessage.type === 'CHAT',
          'chat-message': !chatMessage.isFromRealAgent() && !chatMessage.isFromCustomer(),
          'without-extended-mirror-agent':
            !extendedMirror &&
            chatMessage.isFromRealAgent() &&
            (chatMessage.type === 'CHAT' || chatMessage.type === 'CHAT_AUTOMATIC_MESSAGE'),
          'without-extended-mirror-visitor': !extendedMirror && chatMessage.isFromCustomer() && chatMessage.type === 'CHAT',
          'chat-message-margin':
            chatMessage.type === 'CHAT' ||
            chatMessage.type === 'CHAT_AUTOMATIC_MESSAGE' ||
            chatMessage.type === 'DISCONNECT' ||
            chatMessage.type === 'FILE'
        }"
      >
        <chat-message
          [chat]="chatSocketService.activeChat"
          [msg]="chatMessage"
          [displayCopyLayer]="chatMessage === messageToCopy"
          (burgerClick)="burgerClick($event)"
          (copyToRoom)="copyToRoom($event)"
          *ngIf="
            chatMessage.type === 'CHAT' ||
            chatMessage.type === 'CHAT_AUTOMATIC_MESSAGE' ||
            chatMessage.type === 'DISCONNECT' ||
            chatMessage.type === 'FILE' ||
            chatMessage.type === 'AUTOMATIC'
          "
        >
        </chat-message>

        <div class="chat-transfer" *ngIf="chatMessage.type === 'TRANSFER_COMMENT'">
          <span class="chat-transfer-title"
            >{{ 'agent:panel.chat.message_box.comment' | translate }} {{ chatMessage.lastName }} {{ chatMessage.firstName }}
          </span>
          <time class="chat-transfer-title chat-time">{{ chatMessage.date | localizedDate: 'HH:mm' }}</time>
          <p class="chat-transfer-content">{{ chatMessage.content }}</p>
        </div>

        <div *ngIf="chatMessage.type === 'DEMAND_SCREEN_SHARING'" class="chat-demand-screen-sharing-message system-message-like">
          <p>{{ 'agent:panel.chat.message_box.screen-sharing.demand_sent' | translate }}</p>
        </div>
        <div *ngIf="chatMessage.type === 'REFUSE_SCREEN_SHARING'" class="chat-refused-screen-sharing-message system-message-like">
          <p>{{ 'agent:panel.chat.message_box.screen-sharing.demand_refused' | translate }}</p>
        </div>
        <div *ngIf="chatMessage.type === 'CANCEL_SCREEN_SHARING'" class="chat-refused-screen-sharing-message system-message-like">
          <p>{{ 'agent:panel.chat.message_box.screen-sharing.demand_cancelled' | translate }}</p>
        </div>
        <div *ngIf="chatMessage.type === 'ACCEPTED_SCREEN_SHARING'" class="chat-screen-sharing-accepted-message system-message-like">
          <p>{{ 'agent:panel.chat.message_box.screen-sharing.demand_accepted' | translate }}</p>
        </div>
        <div *ngIf="chatMessage.type === 'END_SCREEN_SHARING'" class="chat-screen-sharing-ended-message system-message-like">
          <p>{{ 'agent:panel.chat.message_box.screen-sharing.ended' | translate }}</p>
        </div>
        <div *ngIf="chatMessage.type === 'FAILURE_SCREEN_SHARING'" class="chat-screen-sharing-ended-message system-message-like">
          <p>{{ 'agent:panel.chat.message_box.screen-sharing.failed' | translate }}</p>
        </div>
      </li>
      <li>
        <div *ngIf="chat.isCustomerInactive || chat.tab.closedByClient" class="chat-screen-sharing-ended-message system-message-like">
          <p>{{ 'agent:panel.chat.message_box.visitor-left' | translate }}</p>
        </div>
      </li>
      <li>
        <chat-attachment-preview
          *ngIf="attachmentInfo"
          [attachments]="attachmentInfo.progressResponse"
          (onCancel)="onCancel($event)"
          (onUpload)="onUpload($event)"
        ></chat-attachment-preview>
      </li>
      <!-- CHAT TYPING MESSAGE !-->
      <!--<li
        #chatTyping
        *ngIf="
          chatSocketService.activeChat.typing &&
          (chatSocketService.activeChat.typingCounterCustomer > 0 || chatSocketService.activeChat.typingCounterAgent > 0)
        "
        class="system-message"
      >
        <chat-message-preview [msges]="chatSocketService.activeChat.typing"></chat-message-preview>
      </li>-->
    </ul>
    <div
      #chatTyping
      class="system-message chat-typing"
      *ngIf="
        chatSocketService.activeChat.typing &&
        (chatSocketService.activeChat.typingCounterCustomer > 0 || chatSocketService.activeChat.typingCounterAgent > 0)
      "
    >
      <chat-message-preview
        [msges]="chatSocketService.activeChat.typing"
        [customerCardId]="chatSocketService.activeChat.customerCardId"
      ></chat-message-preview>
    </div>
    <!-- CHAT ATTACHMENTS CONTAINER  -->
    <chat-attachment-layer
      *ngIf="
        (attachmentInfo && attachmentInfo.validatedFiles && attachmentInfo.validatedFiles.length > 0) ||
        (attachmentInfo && attachmentInfo.warnings && attachmentInfo.warnings.length > 0)
      "
      [files]="attachmentInfo.validatedFiles"
      [warnings]="attachmentInfo.warnings"
      (onRemoveFile)="removeFile($event)"
      (onRemoveWarning)="removeWarning($event)"
    >
    </chat-attachment-layer>

    <!-- NEW MESSAGE CONTAINER -->
    <form id="message-box" (ngSubmit)="sendNewMessage()" *ngIf="!conversationCloseByTheClient">
      <div class="icon-actions" *ngIf="canSendAttachment || enableSmiley">
        <div
          *ngIf="canSendAttachment"
          title=" - {{ 'agent:panel.chat.attachment.max_attachment_count' | translate: { count: count } }} &#013; - {{
            'agent:panel.chat.attachment.authorized_format' | translate: { extensions: extensions }
          }}"
        >
          <button
            type="button"
            mat-icon-button
            class="cng-ico_add_PJ"
            (click)="fileInput.click()"
            [disabled]="fileCountExceeded()"
          ></button>
          <input
            #fileInput
            name="fileList"
            type="file"
            [disabled]="fileCountExceeded()"
            (change)="onFileChange($event)"
            multiple
            accept="{{ extensions }}"
          />
        </div>
        <div
          [ngClass]="showSmileArea ? ' smile-area' : 'smiley-button-container'"
          title="{{ 'agent:panel.chat.smiley.label' | translate }}"
          *ngIf="enableSmiley"
        >
          <!-- COPY LAYER MENU -->
          <mat-menu #copyLayerMenu="matMenu" xPosition="before">
            <chat-emoji (onEmojiSelect)="selectEmoji($event)"></chat-emoji>
          </mat-menu>
          <chat-emoji *ngIf="showSmileArea" (onEmojiSelect)="selectEmoji($event)" (click)="showSmileArea = !showSmileArea"></chat-emoji>

          <button type="button" mat-icon-button class="cng-ico_smiley" [matMenuTriggerFor]="copyLayerMenu">
            <span class="nodisplay">{{ 'agent:panel.chat.smiley.label' | translate }}</span>
          </button>
        </div>
      </div>
      <label for="chatTextArea" class="nodisplay">{{ 'agent:panel.chat.textarea.default.message' | translate }}</label>
      <div
        id="chatTextArea"
        name="chatTextArea"
        #chatTextArea
        [attr.data-placeholder]="'agent:panel.chat.textarea.default.message' | translate"
        contenteditable="true"
        [ngClass]="showSmileArea ? 'chat-text-area-with-smiley' : ''"
        (keypress)="chatBoxKeyPressed($event)"
        (paste)="handlePastAction($event)"
      ></div>
      <button mat-button type="submit" class="submit_btn cng-ico_chat_envoi">
        <span class="nodisplay">{{ 'agent:panel.chat.button.send_message' | translate }}</span>
        <span class="label">{{ 'agent:panel.chat.button.send' | translate }}</span>
      </button>
    </form>
  </div>
</div>
<div *ngIf="extendedMirror && reduced" id="reduced-chat">
  <h3>{{ 'agent:panel.chat.header.name' | translate }}</h3>
  <button
    mat-icon-button
    (click)="reduced = !reduced"
    class="cng-ico_win_grandir"
    title="{{ 'agent:panel.chat.button.expand' | translate }}"
  ></button>
</div>
